var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.656 24.556l-1.528-1.712-1.59 1.712H25.7v-7.884h-3.117l3.911-8.86h3.79l1.344 3.055V7.81h4.705l.795 2.322.794-2.322h3.606V6.467c0-.795-.672-1.467-1.467-1.467H8.467C7.672 5 7 5.672 7 6.467v19.066C7 26.328 7.672 27 8.467 27H40.06c.795 0 1.467-.672 1.467-1.467v-.977h-2.872z",
    fill: "#0071CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.083 23.7h2.506l-3.3-3.483 3.3-3.422h-2.444l-2.017 2.2-2.017-2.2h-2.505l3.3 3.422-3.3 3.483h2.444l2.017-2.261 2.016 2.261z",
    fill: "#0071CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.633 22.111v-1.1h3.912v-1.528h-3.912v-1.1h3.973v-1.588h-5.867V23.7h5.867v-1.589h-3.973zM39.694 15.817h1.834V8.91h-2.872l-1.528 4.278L35.6 8.91h-2.994v6.906H34.5v-4.828l1.772 4.828h1.65l1.773-4.828v4.828zM29.55 8.911h-2.444l-3.056 6.906h2.078l.55-1.406h3.178l.61 1.406h2.14L29.55 8.91zm-2.139 3.972l.917-2.26.916 2.26h-1.833zM39.817 20.033l1.772 1.895v-3.79l-1.772 1.895z",
    fill: "#0071CE"
  })));
}
export default SvgAmericanExpress;